import store from 'store';
import { v4 as uuid } from 'uuid';
import { Moment } from 'moment-timezone';
import { ActorType } from 'actions/prospectMessage/prospectMessageDtos';
import { PhoneSearchType } from './PhoneSearch';
import { SmsMessage } from './TwoWaySms';

export interface ProspectMessage {
    id?: number | undefined;
    uuid?: string;
    marketplaceId: number;
    prospectId: number;
    senderId: number;
    senderType: ActorType;
    receiverId: number;
    receiverType: ActorType;
    message: string;
    sentAt?: Date;
    receivedAt?: Date;
    readAt?: Date;
    createdAt?: Moment;
}

export interface Prospect {
    id: number;
    uuid?: string;
    phone: string;
}

export interface ProspectConversation {
    prospect: Prospect;
    totalMessages: number;
    unreadMessages: number;
    lastMessage: ProspectMessage;
}

export interface ProspectConversationDetail {
    prospect: Prospect;
    unreadMessages: number;
    lastMessage: ProspectMessage;
    messages: Array<ProspectMessage>;
    meta: Meta;
}

export interface Meta {
    page: number;
    size: number;
    totalEntries: number;
    totalPages: number;
}

export interface ProspectConversations {
    prospectConversations: Array<ProspectConversation>;
    meta: Meta;
}

export interface EmptyMessage {
    message: string;
    phone: string;
}

export interface Message {
    id: number;
    phone: string;
    type: PhoneSearchType;
    message: ProspectMessage | SmsMessage;
}

export const createEmptyProspectMessage = (prospectId: number): ProspectMessage => {
    const marketplaceId = store.getState().login.auth.marketplaceId ?? 1;
    return {
        uuid: uuid(),
        marketplaceId: marketplaceId,
        prospectId: prospectId,
        senderId: 0,
        senderType: ActorType.MARKETPLACE,
        receiverId: prospectId,
        receiverType: ActorType.PROSPECT,
        message: ''
    };
};
